<template>
    <v-dialog
        ref="createDialog"
        v-model="show"
        :confirm-disabled="confirmDisabled"
        @confirm.prevent="create"
        kind="modal"
        status="primary"
        semantic="semantic"
        confirm-text="确定"
        cancel-text="取消"
        class="v-dialog--robot-create"
    >
        <div
            slot="title"
            class="create__title"
        >
            新建应用机器人
        </div>
        <div>
            <v-form
                :model="model"
                size="small"
                kind="desc"
            >
                <v-form-item
                    v-if="types.length > 1"
                    v-model="formErrors.barCode"
                    :rules="formRules.barCode"
                    name="barCode"
                    label="选择套餐"
                    required="套餐必选"
                >
                    <v-radio-group
                        v-model="model.barCode"
                        kind="button"
                    >
                        <v-radio
                            v-for="{ barCode, comboName } in types"
                            :key="barCode"
                            :value="barCode"
                            name="barCode"
                        >
                            {{ comboName }}
                        </v-radio>
                    </v-radio-group>
                </v-form-item>
                <v-form-item
                    v-model="formErrors.robotName"
                    :rules="formRules.robotName"
                    name="robotName"
                    label="昵称"
                    required="昵称必填"
                    error-placement="top-right"
                >
                    <v-input
                        v-model="model.robotName"
                        name="robotName"
                        placeholder="请输入机器人昵称"
                        style="width:400px;"
                        limit="10"
                        kind="frame"
                    />
                </v-form-item>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import Gateway from '@/utils/Gateway';

export default {
    name: 'BigRobotCreate',
    props: {
        robotTypes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            show: false,
            model: {
                gptFlag: 1,
                barCode: '',
                robotName: '',
            },
            formRules: {
                barCode: [
                    { validate: value => !!value, message: '请选择套餐' },
                ],
                robotName: [
                    { betweenLength: [1, 10], message: '昵称必须在1-10个字符之间' },
                ],
            },
            formErrors: {
                barCode: '',
                robotName: '',
            },
            confirmDisabled: true,
        };
    },
    computed: {
        types() {
            // eslint-disable-next-line max-len
            const result = this.robotTypes.filter(({ gptTotalQuota, gptUsedQuota }) => gptTotalQuota - gptUsedQuota > 0);
            return result;
        },
    },
    watch: {
        model: {
            handler(val) {
                const { barCode, robotName } = val;
                const onlyFlag = this.types.length === 1;
                this.confirmDisabled = (onlyFlag ? false : !barCode) || !robotName || robotName.length > 10;
            },
            deep: true,
        },
        types: {
            handler(val) {
                if (val.length === 1) this.model.barCode = this.types[0].barCode;
            },
            deep: true,
        },
    },
    methods: {
        open() {
            this.init();
            this.show = true;
        },
        init() {
            this.model = {
                gptFlag: 1,
                barCode: '',
                robotName: '',
            };
            this.formErrors = {
                barCode: '',
                robotName: '',
            };
        },
        create() {
            this.confirmDisabled = true;
            if (this.types.length === 1) this.model.barCode = this.types[0].barCode;
            Gateway.post(
                '/v1/robot/create',
                { ...this.model, robotId: this.model.barCode },
                { timeout: 60000 },
            )
                .then(() => {
                    this.confirmDisabled = false;
                    this.show = false;
                    this.$message.success('开通成功');
                    this.$emit('afterCreate');
                })
                .catch((message) => this.$message.error(message || '大模型机器人新建失败'));
        },
    },
};
</script>

<style lang="less" scoped>
.v-dialog--robot-create {
    /deep/ .v-descriptions--content {
        position: unset;
    }
    /deep/ .v-description-item {
        width: 100% !important;
        margin: 0;

        &-content {
            width: 100%;
        }

        &--value {
            margin: 0;
            text-align: left !important;
        }
    }
}
</style>
